import { api, API, formatApiError, getToken } from "./api";

export const inventoryApi = {
  list: (params) => api.get("/admin/products", { params }),
  get: (id) => api.get(`/admin/products/${id}`),
  create: (payload) => api.post("/admin/products", payload),
  update: (id, payload) => api.patch(`/admin/products/${id}`, payload),
  updatePricing: (id, payload) => api.patch(`/admin/products/${id}/pricing`, payload),
  updateType: (id, payload) => api.patch(`/admin/products/${id}/type`, payload),
  initializeMasonJar: (id, payload) => api.post(`/admin/products/${id}/variants/initialize`, payload),
  updateVariant: (productId, variantId, payload) => api.patch(`/admin/products/${productId}/variants/${variantId}`, payload),
  applyVariantInventory: (productId, variantId, payload) => api.post(`/admin/products/${productId}/variants/${variantId}/inventory`, payload),
  previewPresets: (payload = {}) => api.post("/admin/products/presets/preview", payload),
  applyPresets: (payload) => api.post("/admin/products/presets/apply", payload),
  squareCatalogStatus: () => api.get("/admin/square/catalog/status"),
  squareIntegrationStatus: () => api.get("/admin/integrations/square/status"),
  squareCatalogPreview: (payload = {}) => api.post("/admin/square/catalog/preview", payload),
  squareCatalogApply: (payload) => api.post("/admin/square/catalog/apply", payload),
  squareSyncProduct: (productId, payload) => api.post(`/admin/products/${productId}/square-sync`, payload),
  syncGallery: (items = []) => api.post("/admin/products/sync-gallery", { items }),
  lookup: (code) => api.get("/admin/products/lookup", { params: { code } }),
  apply: (id, payload) => api.post(`/admin/products/${id}/inventory`, payload),
  movements: (id) => api.get(`/admin/products/${id}/inventory-movements`),
  priceHistory: (id) => api.get(`/admin/products/${id}/price-history`),
  previewSquareCatalog: (payload = {}) => api.post("/admin/square/catalog/preview", payload),
  applySquareCatalog: (payload) => api.post("/admin/square/catalog/apply", payload),
  previewMissingBarcodes: (payload = {}) => api.post("/admin/square/barcodes/generate-preview", payload),
  generateMissingBarcodes: (payload) => api.post("/admin/square/barcodes/generate", payload),
  squareInventoryPreview: (payload = {}) => api.post("/admin/square/inventory/preview", payload),
  squareInventoryApply: (payload) => api.post("/admin/square/inventory/apply", payload),
  shippingProfiles: () => api.get("/admin/shipping/profiles"),
  shippingReadiness: () => api.get("/admin/shipping/readiness"),
  shippingSettings: () => api.get("/admin/shipping/settings"),
  updateShippingSettings: (payload) => api.put("/admin/shipping/settings", payload),
  updateShippingProduct: (productId, payload) => api.put(`/admin/products/${productId}/shipping`, payload),
  updateShippingVariant: (productId, variantId, payload) => api.put(`/admin/products/${productId}/variants/${variantId}/shipping`, payload),
};

export async function fetchAdminFile(path) {
  const response = await fetch(`${API}${path}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) {
    let detail = "Unable to load the file.";
    try {
      const body = await response.json();
      detail = formatApiError({ response: { data: body } });
    } catch {
      // Keep the response message sanitized and generic when it is not JSON.
    }
    throw new Error(detail);
  }
  return response.blob();
}

export function dollarsToMinor(value) {
  const normalized = String(value ?? "").trim();
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return null;
  const [whole, fraction = ""] = normalized.split(".");
  const minor = BigInt(whole) * 100n + BigInt((fraction + "00").slice(0, 2));
  if (minor > BigInt(Number.MAX_SAFE_INTEGER)) return null;
  return Number(minor);
}

export function minorToDollars(value) {
  const minor = Number(value || 0);
  if (!Number.isSafeInteger(minor)) return "0.00";
  return `${Math.floor(minor / 100)}.${String(minor % 100).padStart(2, "0")}`;
}
